function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "15px",
    width: "15px",
    id: "Capa_1",
    viewBox: "0 0 437.236 437.236",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f00"
    },
    d: "M31.751,14.388l-4.3,0.683C9.747,17.867-2.389,34.555,0.399,52.267l58.379,370.517   c0.634,4.007,4.089,6.869,8.015,6.869c0.423,0,0.845-0.033,1.276-0.098l52.446-8.25c2.13-0.341,4.04-1.512,5.308-3.243   c1.268-1.748,1.796-3.918,1.455-6.048L68.923,41.448C66.167,23.866,49.772,11.551,31.751,14.388z M73.572,412.225L16.461,49.739   c-1.398-8.868,4.674-17.208,13.526-18.606l4.3-0.683c0.862-0.138,1.723-0.195,2.569-0.195c8.023,0,14.761,5.771,16.013,13.721   l57.087,362.534L73.572,412.225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f00"
    },
    d: "M404.982,23.801c0,0-13.29-1.65-32.628-3.942c-4.438-0.561-8.494,2.658-9.031,7.121   c-0.528,4.454,2.658,8.494,7.112,9.023c11.453,1.357,20.777,2.487,26.459,3.186l22.752,144.559   c-22.459,0.618-81.066,2.073-120.596,1.398c-4.454,0.13-8.185,3.503-8.267,7.99c-0.073,4.495,3.503,8.194,7.99,8.267   c7.113,0.122,14.827,0.171,22.841,0.171c48.227,0,107.061-1.821,107.744-1.837c2.333-0.081,4.52-1.154,6.007-2.943   c1.488-1.796,2.13-4.146,1.772-6.446L412.005,30.597C411.444,27.02,408.575,24.24,404.982,23.801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f00"
    },
    d: "M343.148,25.549c0.52-4.463-2.682-8.494-7.137-9.006c-24.922-2.886-54.396-6.17-84.025-8.559   C199.671,3.829,86.399,33.368,81.603,34.628c-4.341,1.146-6.934,5.592-5.796,9.933c0.959,3.642,4.251,6.056,7.86,6.056   c0.683,0,1.374-0.089,2.073-0.268c1.146-0.293,115.458-30.19,164.937-26.158c23.37,1.878,48.332,4.422,83.464,8.494   C338.604,33.247,342.636,30.003,343.148,25.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f00"
    },
    d: "M262.83,183.942c-22.378-1.967-132.008,21.817-153.915,30.628   c-4.162,1.674-6.186,6.405-4.511,10.575c1.276,3.178,4.324,5.097,7.543,5.097c1.008,0,2.032-0.187,3.024-0.585   c22.134-8.909,128.318-31.108,146.404-29.515c4.479,0.439,8.421-2.902,8.82-7.373C270.601,188.283,267.3,184.34,262.83,183.942z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.0880ff7c4873463daea40d2389c7f4ea.svg";
export { ForwardRef as ReactComponent };